module.exports = __webpack_public_path__ + "static/img/img04.06b9885.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img04.png
// module id = YU5H
// module chunks = 1